import { hdrm } from '@yola/ws-sdk';

const getParentElement = (element) => {
  const parentRefId = hdrm.instance.driver.referenceMap.getParentReferenceId(element);
  return hdrm.accessors.getLiveElement(parentRefId);
};

export default getParentElement;
